import { memo } from "react";
import { Modal, Table } from "antd";
import { useSelector } from "react-redux";
import { formatDateToDDMMYYYY } from "utils/CommonFunctions";

const columns = [
  {
    title: "Sr. No.",
    dataIndex: "srNo",
    key: "srNo",
    render: (text, data, index) => index + 1,
  },
  {
    title: "No. of Embryo",
    dataIndex: "no_of_embryo",
    key: "no_of_embryo",
  },
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
    render: (e) => {
      return e ? formatDateToDDMMYYYY(e) : null;
    },
  },
  {
    title: "PG Progress",
    dataIndex: "pg_progress",
    key: "pg_progress",
  },
  {
    title: "Indication",
    dataIndex: "indication",
    key: "indication",
  },
  {
    title: "Week",
    dataIndex: "week",
    key: "week",
  },
  {
    title: "Notes",
    dataIndex: "notes",
    key: "notes",
  },
];

const intrauterineTableColumns = [
  {
    title: "No Of Intrauterine",
    dataIndex: "no_of_intrauterine",
    key: "no_of_intrauterine",
  },
  {
    title: "Live",
    dataIndex: "live",
    key: "live",
  },
  {
    title: "Blighted",
    dataIndex: "blighted",
    key: "blighted",
  },
];

const CycleOutComeModal = ({ isOpen, onClose }) => {
  const theme = localStorage.getItem("default-theme");

  const { activePatientJourneyModuleDetails } = useSelector(
    ({ dashboard }) => dashboard
  );

  return (
    <>
      <Modal
        centered
        open={isOpen}
        title="Cycle Out Come Detail"
        className={`patient-registration-modal theme-${theme}`}
        maskClosable={false}
        onCancel={() => onClose()}
        width={860}
      >
        <div className="modal-details">
          <div className="modal-content-details">
            <div className="details">
              <div className="details-table">
                <div>Patient ID </div>
                <div>{activePatientJourneyModuleDetails?.patient_id}</div>
                <div>Patient Name</div>
                <div>
                  {activePatientJourneyModuleDetails?.patient_full_name}
                </div>
                <div>Partner Name</div>
                <div>
                  {activePatientJourneyModuleDetails?.partner_full_name}
                </div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">Patient Details</div>
              <div className="details-table">
                <div>IVF ID</div>
                <div>{activePatientJourneyModuleDetails?.ivf_flow_id}</div>
                <div>1st BHCG (miU/ml)</div>
                <div>{activePatientJourneyModuleDetails?.bhcg_1}</div>
                <div>2nd BHCG (miU/ml)</div>
                <div>{activePatientJourneyModuleDetails?.bhcg_2}</div>
                <div>LMP</div>
                <div>{activePatientJourneyModuleDetails?.lmp}</div>
                <div>Clinical Preg. Determine on</div>
                <div>
                  {
                    activePatientJourneyModuleDetails?.clinical_preg_determine_on
                  }
                </div>
                <div>Clinical Preg. Outcome</div>
                <div>
                  {activePatientJourneyModuleDetails?.clinical_preg_outcome}
                </div>
                <div>Today date</div>
                <div>{activePatientJourneyModuleDetails?.today_date}</div>
                <div>Calculated Birth Date</div>
                <div>
                  {activePatientJourneyModuleDetails?.calculated_birth_date
                    ? formatDateToDDMMYYYY(
                        activePatientJourneyModuleDetails?.calculated_birth_date
                      )
                    : ""}
                </div>
                <div>Current Preg. Week & Rest Days</div>
                <div>
                  {activePatientJourneyModuleDetails?.current_preg_week_days}
                </div>
                <div>No. of Fetal Sac</div>
                <div>{activePatientJourneyModuleDetails?.no_of_fatal_sac}</div>
              </div>
            </div>
            {/* <div className="details">
            <div className="table-title">
              Other Details
            </div>
            <div className="details-table">
              <div>No. of Embryo</div>
              <div>{activePatientJourneyModuleDetails?.no_of_embryo}</div>
              <div>Date</div>
              <div>{activePatientJourneyModuleDetails?.date}</div>
              <div>PG Progress</div>
              <div>{activePatientJourneyModuleDetails?.pg_progress}</div>
              <div>Indication</div>
              <div>{activePatientJourneyModuleDetails?.indication}</div>
              <div>Week</div>
              <div>{activePatientJourneyModuleDetails?.week}</div>
              <div>Notes</div>
              <div>{activePatientJourneyModuleDetails?.notes}</div>
            </div>
          </div> */}

            <div className="details">
              <div className="table-title">Other Details</div>
              <div className="details-table">
                <div>Cervical Encerclage</div>
                <div>
                  {activePatientJourneyModuleDetails?.cervical_encerclage}
                </div>
                <div>PG Week</div>
                <div>{activePatientJourneyModuleDetails?.pg_week}</div>
                <div>Method</div>
                <div>{activePatientJourneyModuleDetails?.method}</div>
                <div>Done By</div>
                <div>{activePatientJourneyModuleDetails?.method_done_by}</div>
                <div>Method Done by Other</div>
                <div>
                  {activePatientJourneyModuleDetails?.method_done_by_other}
                </div>
              </div>
            </div>

            {/* <div className="details">
              <div className="table-title">
                Intrauterine Pregnancy Details
              </div>
              <div className="details-table">
                <div>No. of Intrauterine</div>
                <div>{activePatientJourneyModuleDetails?.no_of_intrauterine}</div>
                <div>Live</div>
                <div>{activePatientJourneyModuleDetails?.live}</div>
                <div>Blighted</div>
                <div>{activePatientJourneyModuleDetails?.blighted}</div>
              </div>
            </div> */}
            <div className="details">
              <div className="table-title">Heterotopic Pregnancy Details</div>
              <div className="details-table">
                <div>Right Tube</div>
                <div>{activePatientJourneyModuleDetails?.right_tube}</div>
                <div>Left Tube</div>
                <div>{activePatientJourneyModuleDetails?.left_tube}</div>
                <div>Extrautenne No.</div>
                <div>{activePatientJourneyModuleDetails?.extrauterine_no}</div>
                <div>Ovarian</div>
                <div>{activePatientJourneyModuleDetails?.ovarian}</div>
                <div>Cervical</div>
                <div>{activePatientJourneyModuleDetails?.cervical}</div>
                <div>Done By</div>
                <div>
                  {activePatientJourneyModuleDetails?.heterotopic_done_by}
                </div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">Management Details</div>
              <div className="details-table">
                <div>Date</div>
                <div>{activePatientJourneyModuleDetails?.management_date}</div>
                <div>Operatic Gynec</div>
                <div>{activePatientJourneyModuleDetails?.operating_gynec}</div>
                <div>Laparoscopy</div>
                <div>{activePatientJourneyModuleDetails?.laparoscopy}</div>
                <div>Laparotomy</div>
                <div>{activePatientJourneyModuleDetails?.paratomy}</div>
                <div>Medical</div>
                <div>{activePatientJourneyModuleDetails?.medical}</div>
                <div>Note (Complications)</div>
                <div>{activePatientJourneyModuleDetails?.note}</div>
              </div>
            </div>
          </div>
          <div className="cmn_table_wrap table_wrapper mb-2">
            <h3 className="mt-3">Other Details</h3>
            <Table
              columns={columns}
              dataSource={activePatientJourneyModuleDetails?.table_detail}
              pagination={false}
            />
          </div>
          <div className="cmn_table_wrap table_wrapper mb-2">
            <h3 className="mt-3">Intrauterine Pregnancy Details</h3>
            <Table
              columns={intrauterineTableColumns}
              dataSource={
                activePatientJourneyModuleDetails?.intrauterine_pregnancy
              }
              pagination={false}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default memo(CycleOutComeModal);
